import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../lib/utils";
import * as React from "react";
const Separator = React.forwardRef(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (React.createElement(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn("s-shrink-0", "s-bg-separator dark:s-bg-separator-night", orientation === "horizontal"
        ? "s-h-[1px] s-min-w-full"
        : "s-min-h-full s-w-[1px] s-self-stretch", className !== null && className !== void 0 ? className : ""), ...props })));
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
//# sourceMappingURL=Separator.js.map